export default __webpack_public_path__ + "static/media/guide-img-6.d7c4bef2.png";